import { sendPubSubEvent } from '../api';

export const schoolClicked = async (school = {}) => {
  if (!school) {
    return;
  }

  await sendPubSubEvent('user.clicked.school', {
    id: school.id,
    shortId: school.shortId,
    externalId: school.external_id,
  });
};

export const schoolVisited = async (school = {}) => {
  if (!school) {
    return;
  }

  await sendPubSubEvent('user.visited.school', {
    id: school.id,
    shortId: school.shortId,
    externalId: school.external_id,
  });
};
